import { useFeatureFlag } from '@liveauctioneers/hammer-ui-core/featureFlags/hooks';

import { useAppSelector } from '@/redux/hooks';
import { getIsVipConfirmationEligible } from '@/redux/modules/account/user/user.selectors';
import { FeatureFlagKeys } from '@/types/FeatureFlags';

/**
 * VIP UI requires the feature flag and backend eligibility together.
 * The flag can be on for accounts the backend has not marked eligible; those accounts must not see it.
 */
export const useIsVipEnabled = () => {
    const isFeatureEnabled = useFeatureFlag(FeatureFlagKeys.VipBenefits);
    const isBackendEligible = useAppSelector(getIsVipConfirmationEligible);

    return isFeatureEnabled && isBackendEligible;
};
